import { SubTab } from "./SubTab";

export default SubTab;